// extracted by mini-css-extract-plugin
module.exports = {"optionName":"AiCopilotSection_optionName__2QLn1"};